import { render, staticRenderFns } from "./NotificationCrmClientBirthday.vue?vue&type=template&id=3eee7d07&scoped=true&lang=pug&"
import script from "./NotificationCrmClientBirthday.vue?vue&type=script&lang=js&"
export * from "./NotificationCrmClientBirthday.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCrmClientBirthday.vue?vue&type=style&index=0&id=3eee7d07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eee7d07",
  null
  
)

export default component.exports